import { Button } from 'components/universal/button';
import { HowToGetCertificate } from 'components/universal/howToGetCertificate';
import { Modal } from 'components/universal/modal';
import Paragraph from 'components/universal/paragraph';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { hideModal, showModal } from "store/modal/modalSlice";
import cls from './certificate.module.scss';

interface IProps {
    type?: 'list' | 'single';
}

export const Certificate = ({ type ='single' }: IProps) => {
    const { t } = useTranslation('', {
        keyPrefix: 'elearning.handHygiene.courseLayout.overview',
    });
    const dispatch = useDispatch();
    
    const hideModalHandle = () => {
        dispatch(hideModal());
    }

    const showPopup = () => {
        dispatch(showModal());
    }
    return (
        <div className={type === 'list' ? cls.certificateList : cls.certificate}>
            <Modal className={cls.modal}>
                <HowToGetCertificate onCancel={hideModalHandle} />
            </Modal>
            {
                type === 'single' && (
                    <>
                        <Paragraph className={cls.text} fontWeight={700}>
                            {t('claimedCertificate')}
                        </Paragraph>
                    </>
                )
            }
            <Button className={type === 'list' ? cls.btnList : cls.btn} onClick={showPopup}>
                {type === 'list' ? t('downloadCertificateList') : t('downloadCertificate')}
            </Button>
        </div>
    );
};
